import { Route } from "components/utils";
import { Dashboard as InventoryDashboard } from "pages/inventory/dashboard/Dashboard";
import { NotFound } from "pages/notFound";
import { RouteComponentProps, Switch } from "react-router-dom";

export const Dashboard = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        component={InventoryDashboard}
        exact={true}
        path={`${match.path}`}
        title="Milo - produkty"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
